import { ServerValueEnum } from '../../utils/enum'

const SearchType = new ServerValueEnum({
  DISTRIBUTION_LIST: { serverValue: 'distribution_list' },
  FORUM: { serverValue: 'public_group' },
  GROUP: { serverValue: 'group' },
  ORGANIZATION: { serverValue: 'organization' },
  PATIENT: { serverValue: 'patient_account' },
  TAG: { serverValue: 'tag' },
  USER: { serverValue: 'account' },
})

export default SearchType
